type ShieldsLogoProps = {
  className?: string;
  showWordmark?: boolean;
  wordmark?: string;
  tone?: "light" | "dark";
};

export function ShieldsLogo({
  className = "",
  showWordmark = true,
  wordmark = "SHIELDS",
  tone = "light",
}: ShieldsLogoProps) {
  return (
    <span
      className={`shields-logo shields-logo--${tone} ${className}`}
      aria-label={showWordmark ? "Shields" : undefined}
      aria-hidden={showWordmark ? undefined : true}
    >
      <svg
        viewBox="0 0 472 512"
        className="shields-logo__mark"
        focusable="false"
        aria-hidden="true"
      >
        <path
          d="M235 35 158 64 53 96 47 105 54 249 83 339 114 391 157 437 203 473 234 489 288 458 355 393 391 332 402 291 368 259 315 231 145 190 130 179 129 152 233 117 348 151 354 159 348 228 355 237 403 267 413 262 420 229 425 156 422 97Z M130 263 132 261 158 267 175 269 187 273 213 276 228 280 239 282 248 283 260 288 273 291 280 295 293 299 308 306 318 315 318 320 311 331 309 337 305 341 300 351 295 358 288 364 285 369 280 374 276 376 270 383 262 389 253 394 250 398 244 400 241 404 234 407 228 401 220 397 217 393 212 391 196 378 182 364 172 350 167 345 159 333 153 322 150 312 145 305 142 295 136 285 136 280 130 271Z"
          fill="#D9AA42"
          fillRule="evenodd"
          clipRule="evenodd"
          stroke="#8E5C12"
          strokeWidth="8"
          strokeLinejoin="round"
        />
        <path
          d="M235 35 158 64 53 96 47 105 54 249 83 339 114 391 157 437 203 473 234 489 288 458 355 393 391 332 402 291 368 259 315 231 145 190 130 179 129 152 233 117 348 151 354 159 348 228 355 237 403 267 413 262 420 229 425 156 422 97Z"
          fill="none"
          stroke="#F4D57A"
          strokeWidth="5"
          strokeLinejoin="round"
          opacity=".9"
        />
      </svg>
      {showWordmark ? <span className="shields-logo__word">{wordmark}</span> : null}
    </span>
  );
}
